import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse, Typography, Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Link from 'next/link';
import { client } from '../utils/sanity-client';
import BlockContent from '@sanity/block-content-to-react';

const { Panel } = Collapse;
const { Paragraph } = Typography;

const Glossary = () => {
  const [glossaryTerms, setGlossaryTerms] = useState([]);
  const [expandAll, setExpandAll] = useState(false);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    client
      .fetch('*[_type == "glossary"] | order(title asc)')
      .then((data) => setGlossaryTerms(data))
      .catch(console.error);
  }, []);

  const truncateText = (blocks, maxLength) => {
    let truncated = '';
    let isTruncated = false;

    for (const block of blocks) {
      if (block._type === 'block') {
        for (const child of block.children) {
          if (truncated.length + child.text.length <= maxLength) {
            truncated += child.text;
          } else {
            const remaining = maxLength - truncated.length;
            truncated += child.text.slice(0, remaining) + '...';
            isTruncated = true;
            break;
          }
        }
      }
      if (isTruncated) break;
    }

    return { truncated: [{ _type: 'block', children: [{ _type: 'span', text: truncated }] }], isTruncated };
  };

  const filteredGlossaryTerms = glossaryTerms.filter((term) => {
    if (filter === 'all') return true;
    return term.title.toLowerCase().startsWith(filter.toLowerCase());
  });

  const handleMenuClick = (e) => {
    setFilter(e.key);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="all">All</Menu.Item>
      {/* Add menu items for each letter of the alphabet */}
      {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter) => (
        <Menu.Item key={letter}>{letter}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Dropdown overlay={menu}>
            <Button>
              Filter: {filter.toUpperCase()} <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
        <Col>
          <Button onClick={() => setExpandAll(!expandAll)}>
            {expandAll ? 'Collapse All' : 'Expand All'}
          </Button>
        </Col>
      </Row>
      <Collapse
        accordion={!expandAll}
        activeKey={expandAll ? glossaryTerms.map((_, index) => index.toString()) : undefined}
      >
        {filteredGlossaryTerms.map((term, index) => {
          const { truncated, isTruncated } = truncateText(term.definition, 1000);
          return (
            <Panel header={term.title} key={index}>
              <BlockContent blocks={truncated} />
              {isTruncated && (
                <div style={{ marginTop: '1rem' }}>
                  {term.fullPageLink ? (
                    <a href={term.fullPageLink} target="_blank" rel="noopener noreferrer">
                      View full entry
                    </a>
                  ) : (
                    <Link href={`/glossary/${term.slug.current}`}>
                      <a>View full entry</a>
                    </Link>
                  )}
                </div>
              )}
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};

export default Glossary;
